import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export type VariantMap = Record<string, React.ComponentType<IconProps>>;

export interface VariantIconProps extends IconProps {
  variant?: string;
}

export function createVariantIcon(
  iconMap: VariantMap,
  defaultVariant: string
): React.FC<VariantIconProps> {
  const VariantIconComponent: React.FC<VariantIconProps> = ({
    variant = defaultVariant,
    ...props
  }) => {
    const IconComponent = iconMap[variant];

    if (!IconComponent) {
      console.warn(`Variant '${variant}' not found in iconMap`);
      return null;
    }

    return React.createElement(Icon, { as: IconComponent, ...props });
  };

  return VariantIconComponent;
}
